import { makeAutoObservable } from 'mobx'
import { api, DocumentationSortType } from 'utils'
import { IParagraph } from 'models'


class DocumentationStore {
  constructor() {
    makeAutoObservable(this)
  }

  async getChapters(pageType: integer) {
    const response = await api.get(`api/Documentation/getChapters?pageType=${pageType}`)
    if (response.status !== 200)
      throw new Error(response.data && (response.data.Description || response.data.Title || ''))

    return response.data
  }

  async createChapter(title: string, pageType: integer) {
    const response = await api.post(`api/Documentation/createChapter`, null, {
      params: {
        title,
        pageType
      }
    })
    if (response.status !== 200)
      throw new Error(response.data && (response.data.Description || response.data.Title || ''))

    return response.data
  }

  async updateChapter(id: string, title: string) {
    // Response not full (Paragraphs is null)
    const response = await api.put(`api/Documentation/updateChapter`, null, {
      params: {
        id,
        title
      }
    })
    if (response.status !== 200)
      throw new Error(response.data && (response.data.Description || response.data.Title || ''))

    return response.data
  }

  async deleteChapter(id: string) {
    const response = await api.delete(`api/Documentation/deleteChapter`, {
      params: { id }
    })
    if (response.status !== 200)
      throw new Error(response.data && (response.data.Description || response.data.Title || ''))

    return response.data
  }

  // export const getParagraphsForChapter = async (chapterId: any) => {
  //   try {
  //     const response = await apiIdentity.get(`api/Documentation/getParagraphsForChapter?chapterId=${chapterId}`)
  //
  //     return response
  //   } catch (error) {
  //     handleAxiosErrors(error as AxiosError)
  //     throw error
  //   }
  // }


  async createParagraph(chapterId: string, title: string) {
    const data = { Title: title, Description: 'Default content' }
    const response = await api.post(`api/Documentation/createParagraph`, data, {
      params: {
        chapterId
      }
    })
    if (response.status !== 200)
      throw new Error(response.data && (response.data.Description || response.data.Title || ''))

    return response.data
  }

  async updateParagraph(id: string, data: IParagraph) {
    const response = await api.put(`api/Documentation/updateParagraph`, data, {
      params: {
        id
      }
    })
    if (response.status !== 200)
      throw new Error(response.data && (response.data.Description || response.data.Title || ''))

    return response.data
  }

  async deleteParagraph(id: string) {
    const response = await api.delete(`api/Documentation/deleteParagraph`, {
      params: { id }
    })
    if (response.status !== 200)
      throw new Error(response.data && (response.data.Description || response.data.Title || ''))

    return response.data
  }

  async changeDocumentationSort(type: DocumentationSortType, data: string[], pageType: integer) {
    const response = await api.post(`api/Documentation/setNumber`, data, {
      params: {
        type,
        pageType
      }
    })
    if (response.status !== 200)
      throw new Error(response.data && (response.data.Description || response.data.Title || ''))

    return response.data
  }

}

export default new DocumentationStore()
